import React from "react";
import ReactDOM from "react-dom";
import {BrowserRouter as Router} from 'react-router-dom'
import "bootstrap/dist/css/bootstrap.min.css"
import {createStore} from 'redux';
import {Provider} from 'react-redux'
import {reducers} from './reducers'
import "./index.css";
import App from "./App";

const store=createStore(reducers)
ReactDOM.render(
  <Provider store={store} >
  	<Router>
  	  <App />
  	</Router>
  </Provider>,
  document.getElementById("root")
);
